export const ALL_CHATS_FOLDER_ID = '__all__'
